import * as t from 'io-ts';
import { DurationDynamicType } from './customTypes/duration';
import { DateTime } from './customTypes/dateTime';
import { DateTypeDynamic } from 'acscp/api/models/customTypes/dateType';
import { TimeDynamicType } from 'acscp/api/models/customTypes/timeType';

export const LegDynamicType = t.intersection([
    t.interface({
        id: t.string,
        departureDate: DateTime,
        departureDateType: DateTypeDynamic,
        departureRangeEndDate: t.union([DateTime, t.null]),
        departureTimeType: TimeDynamicType,
        arrivalDate: DateTime,
        arrivalTimeType: TimeDynamicType,
        isArrivalTimeSpecified: t.boolean,
        departureLocation: t.string,
        departureAirportId: t.union([t.string, t.null]),
        arrivalLocation: t.string,
        arrivalAirportId: t.union([t.string, t.null]),
        flightTimeDuration: t.union([DurationDynamicType, t.null]),
        numberOfPassengers: t.union([t.number, t.null]),
        specialRequests: t.union([t.string, t.null]),
        isFuelStopRequested: t.union([t.boolean, t.null]),
        fuelStopText: t.union([t.string, t.null]),
        cargoWeight: t.union([t.string, t.null]),
    }),
    t.partial({
        numberOfPets: t.union([t.number, t.null]),
    }),
]);

export type Leg = t.TypeOf<typeof LegDynamicType>;
